"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const state = {
    isDataLoading: false,
    status: true,
    message: {
        top: "",
        mid: "",
        bottom: "",
    },
    version: 4,
    isFooter: true,
};
const mutations = {
    SET_SERVER_STATUS(state, data) {
        state.status = data;
    },
    SET_SERVER_LOADING(state, data) {
        state.isDataLoading = data;
    },
    SET_SERVER_MESSAGE(state, data) {
        state.message = data;
    },
    SET_SERVER_VERSION(state, data) {
        state.version = data;
    },
    SET_FOOTER(state, data) {
        state.isFooter = data;
    },
};
exports.default = {
    state,
    mutations,
};
